<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="450px">
        <v-card>
          <v-card-title>
            <span class="text-success">支付成功</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <div class="text-left">
                <p class="text-md-h5">
                  支付金额: <i class="la la-rmb"></i>{{ order.prices / 100 }} 元
                </p>
                <p v-if="order.action !== 'recharge'">
                  <span
                    class="text-md-h6"
                    v-if="order.product.code === 'secret'"
                  >
                    商品名称: 短效代理-IP提取数{{
                      order.product.ip_num
                    }}个-提取间隔{{ order.product.api_rate }}秒
                  </span>
                  <span class="text-md-h5" v-else>
                    商品名称: 隧道代理-每秒最大请求数{{ order.product.qps }}
                  </span>
                </p>
                <p class="text-md-h5" v-else>商品名称: 充值金额</p>
                <p class="text-md-h5">
                  购买时间: {{ order.ctime | parseTime("{y}-{m}-{d} {h}:{i}") }}
                </p>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">确定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { GET_SERVICE } from "../../../core/services/store/service.module";
import { mapGetters } from "vuex";
import { VERIFY_AUTH } from "../../../core/services/store/auth.module";

export default {
  name: "PaySuccess",
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    order: {
      type: Object,
      required: true,
      default: () => ({
        action: "",
        prices: "",
        product: {
          code: "",
        },
        ctime: "",
      }),
    },
  },
  computed: {
    ...mapGetters(["currentServices"]),
  },
  methods: {
    closeDialog() {
      this.$store.dispatch(GET_SERVICE).then();
      this.$store.dispatch(VERIFY_AUTH).then();
      this.$emit("update:dialog", false);
    },
  },
};
</script>

<style scoped></style>
